import { message } from "antd"
//Errors
export const dataFetchError = ()=>{
    message.error('.دریافت اطلاعات با مشکل مواجه شد')

}
export const editError = ()=>{
    message.error('.تغییر اطلاعات با مشکل مواجه شد')

}
export const submitError = ()=>{
    message.error('.ثبت اطلاعات با مشکل مواجه شد')

}
